import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SolarEnergyPage from "../pages/solar/page";
import WindEnergyPage from "../pages/wind/page";
import HydrogenEnergyPage from "../pages/hydrogen/page";
import BlogPage from "../pages/blog/page";
import BlogPostPage from "../pages/blog/post/page";
import BlogAdminPage from "../pages/blog/admin/page";
import BlogEditPage from "../pages/blog/admin/edit/page";
import BlogPreviewPage from "../pages/blog/preview/page";
import PrivacyPolicyPage from "../pages/legal/privacy/page";
import TermsOfServicePage from "../pages/legal/terms/page";
import CookiePolicyPage from "../pages/legal/cookies/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: '/solar-energy-australia',
    element: <SolarEnergyPage />,
  },
  {
    path: '/wind-energy-solutions',
    element: <WindEnergyPage />,
  },
  {
    path: '/hydrogen-energy-australia',
    element: <HydrogenEnergyPage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/:slug",
    element: <BlogPostPage />,
  },
  {
    path: "/blog/preview",
    element: <BlogPreviewPage />,
  },
  {
    path: "/blog/admin",
    element: <BlogAdminPage />,
  },
  {
    path: "/blog/admin/new",
    element: <BlogEditPage />,
  },
  {
    path: "/blog/admin/edit/:slug",
    element: <BlogEditPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "/terms-of-service",
    element: <TermsOfServicePage />,
  },
  {
    path: "/cookie-policy",
    element: <CookiePolicyPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;